import React from "react";
import { useNavigate } from "react-router-dom";

// Единая панель вкладок на весь раздел Rozetka -- рендерится и на
// /integrations/rozetka (Аккаунт/Отправители/Выгрузка/Jobs -- локальные),
// и на /integrations/rozetka/mappings|attributes (Категории/Бренды/
// Характеристики -- локальные там). Вкладки чужой страницы -- обычная
// навигация с передачей текущего аккаунта через ?account=, чтобы не
// переспрашивать его повторно (см. память проекта: аккаунт раньше
// дублировался на странице маппинга).
const ITEMS = [
    { key: "account", label: "Аккаунт", path: "/integrations/rozetka", param: "section" },
    { key: "suppliers", label: "Отправители/цены", path: "/integrations/rozetka", param: "section" },
    { key: "pricing", label: "Цены", path: "/integrations/rozetka", param: "section" },
    { key: "export", label: "Выгрузка", path: "/integrations/rozetka", param: "section" },
    { key: "jobs", label: "Jobs", path: "/integrations/rozetka", param: "section" },
    { key: "orders", label: "Заказы", path: "/integrations/rozetka", param: "section" },
    { key: "payments", label: "Виды оплат", path: "/integrations/rozetka", param: "section" },
    { key: "statuses", label: "Статусы", path: "/integrations/rozetka", param: "section" },
    { key: "categories", label: "Категории", path: "/integrations/rozetka/mappings", param: "tab" },
    { key: "brands", label: "Бренды", path: "/integrations/rozetka/mappings", param: "tab" },
    { key: "attributes", label: "Характеристики", path: "/integrations/rozetka/attributes", param: null },
];

const RozetkaTopBar = ({ activeKey, accountId, localKeys, onLocalSelect }) => {
    const navigate = useNavigate();

    return (
        <div className="ip-tabbar rzm-tabbar-sticky">
            {ITEMS.map((item) => {
                const isLocal = localKeys.includes(item.key);
                const isActive = activeKey === item.key;
                const goToOtherPage = () => {
                    const params = new URLSearchParams();
                    if (accountId) params.set("account", accountId);
                    if (item.param) params.set(item.param, item.key);
                    const query = params.toString();
                    navigate(query ? `${item.path}?${query}` : item.path);
                };
                return (
                    <button
                        key={item.key}
                        type="button"
                        className={isActive ? "ip-tab active" : "ip-tab"}
                        disabled={!isLocal && !accountId}
                        onClick={isLocal ? () => onLocalSelect(item.key) : goToOtherPage}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default RozetkaTopBar;
